import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M50,38 C50,33.5 46.5,30.3 42,30.3 L35,30.3 C30.5,30.3 27,33.5 27,38 L27,42.6 C27,47.1 30.5,50.3 35,50.3 L42,50.3 C43.7,50.3 45,51.6 45,53.3 C45,55 43.7,56.3 42,56.3 L35,56.3 C33.3,56.3 32,55 32,53.3 L32,51.3 L27,51.3 L27,53.3 C27,57.8 30.5,61 35,61 L42,61 C46.5,61 50,57.8 50,53.3 L50,48.7 C50,44.2 46.5,41 42,41 L35,41 C33.3,41 32,39.7 32,38 C32,36.3 33.3,35 35,35 L42,35 C43.7,35 45,36.3 45,38 L45,40 L50,40 L50,38 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
